import { jsx as _jsx } from "react/jsx-runtime";
import { getAcoes } from '../../../api';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import GridBase from '../../../components/grid_base';
var COLUNAS = [
    { field: 'nome', headerName: 'Nome', width: 650 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function Acoes() {
    return _jsx(GridBase, { pagina: PAGINAS.ACOES, paginaPermissao: FUNCIONALIDADES.ACOES, rota: ROUTES.FUNCIONALIDADES, fetchData: function (str, _, pag) { return getAcoes(str, pag); }, columns: COLUNAS });
}
